<template>
  <v-footer
    elevation="0"
    style="background-color: white; max-height: max-content"
  >
    <v-container class="py-4">
      <v-row align="center" justify="center">
        <v-col cols="12" class="d-flex align-center justify-center">
          <v-img
            :src="require(`../assets/${getName()}.png`)"
            contain
            max-height="50px"
            max-width="50px"
            class="mr-3"
          />
          <div>
            <div class="font-weight-bold text-body-1">{{ getCompany() }}</div>
            <div class="text-caption text--secondary">
              © {{ new Date().getFullYear() }}
            </div>
          </div>
        </v-col>
      </v-row>
      <v-col style="display: flex; justify-content: center">
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 8px;
            max-width: 200px;
          "
        >
          <div
            style="display: flex; gap: 12px; margin-top: 4px"
            class="text-body-2"
            v-if="phoneNumbers.length > 0"
          >
            <a
              style="text-decoration: none"
              v-for="phone in phoneNumbers"
              :href="'tel:' + phone"
            >
              <v-icon>mdi-phone</v-icon>
              {{ phone }}
            </a>
          </div>
          <div
            style="display: flex; gap: 12px"
            class="text-body-2"
            v-if="viberNumbers.length > 0"
          >
            <a
              v-for="viberNumber in viberNumbers"
              :href="`viber://add?number=${viberNumber}`"
              style="
                text-decoration: none;
                display: flex;
                align-items: center;
                gap: 6px;
              "
            >
              <img style="width: 22px" src="/viber.svg" />
              {{
                viberNumber.length >= 10 && viberNumber.startsWith("960")
                  ? viberNumber.slice(3)
                  : viberNumber
              }}
            </a>
          </div>
        </div>
      </v-col>
      <!-- Links -->
      <v-row align="center" justify="center">
        <v-col
          cols="12"
          class="d-flex flex-wrap justify-center"
          style="gap: 1.5rem"
        >
          <a
            v-if="getToc()"
            href="/terms-and-conditions"
            class="text-decoration-none text--secondary text-body-2"
            style="transition: color 0.2s"
          >
            Terms & Conditions
          </a>
          <a
            v-if="showAbout()"
            href="/about"
            class="text-decoration-none text--secondary text-body-2"
            style="transition: color 0.2s"
          >
            About Us
          </a>
          <span
            v-else
            class="text--secondary text-body-2"
            style="display: flex; align-items: center; gap: 3.5px"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <img
                  v-bind="attrs"
                  v-on="on"
                  src="/img/environment_friendly.png"
                  alt="Environment Icon"
                  style="height: 28px; width: auto; margin-right: 8px"
                />
              </template>
              <span>Hosted on 100% Renewable Energy</span>
            </v-tooltip>

            Powered by
            <a
              href="https://techverin.com/"
              target="_blank"
              class="text-decoration-none primary--text font-weight-medium"
              style="transition: color 0.2s"
            >
              Techverin
            </a>
          </span>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    phoneNumbers() {
      return [
        this.getConfigValue("Contact phone number 1"),
        this.getConfigValue("Contact phone number 2"),
      ].filter(Boolean);
    },
    viberNumbers() {
      return [
        this.addPrefix(this.getConfigValue("Contact Viber number 1")),
        this.addPrefix(this.getConfigValue("Contact Viber number 2")),
      ].filter(Boolean);
    },
  },
  methods: {
    addPrefix(num) {
      if (!num) return num;
      return num.startsWith("960") ? num : "960" + num;
    },
    getConfigValue(name) {
      const configs = this.$store?.getters?.getConfigs ?? [];
      const config = configs.find((c) => c.name === name);
      return (config?.value ?? "").trim();
    },
    getName() {
      return process.env.VUE_APP_NAME ?? "bmt";
    },
    getCompany() {
      return process.env.VUE_APP_COMPANY ?? "Techverin Pvt. Ltd";
    },
    getToc() {
      return process.env.VUE_APP_TOC ?? "";
    },
    showAbout() {
      if (this.getCompany() === "Techverin Pvt. Ltd") return true;
      return false;
    },
    goToAbout() {
      this.$router.push("/about");
    },
  },
};
</script>
